export enum AlertStatus {
  Success,
  Fail,
}
